import Box from '@mui/material/Box';
import LinkComponent from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderInnerStack, HeaderOuterStack } from './styled';

// Served same-origin on every branded host by the nginx /cdn proxy
// (nginx/client.default.conf, DEV-800)
const PRIVACY_POLICY_PATH = '/cdn/agreements/privacy_policy.html';

interface HeaderWithPolicyTermsProps {
  showLinks?: boolean;
}

const Link = ({ href, title }: { href: string; title: string }) => {
  return (
    <LinkComponent href={href} target="_blank" rel="noopener noreferrer">
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {title}
      </Typography>
    </LinkComponent>
  );
};

export const HeaderWithPolicyTerms = ({
  showLinks = true,
}: HeaderWithPolicyTermsProps): ReactElement => {
  const { t } = useTranslation('integrations');

  return (
    <HeaderOuterStack component="header">
      <Box component="img" src="/assets/logo_240x60.png" alt="logo" />
      {showLinks && (
        <HeaderInnerStack component="nav">
          <Link
            href={PRIVACY_POLICY_PATH}
            title={t('integration/sapConcur.privacyPolicy')}
          ></Link>
        </HeaderInnerStack>
      )}
    </HeaderOuterStack>
  );
};
